// extracted by mini-css-extract-plugin
export var alignBaseline = "_12-9";
export var alignCenter = "_12-5";
export var alignFlexEnd = "_12-7";
export var alignFlexStart = "_12-6";
export var alignSelfBaseline = "_12-e";
export var alignSelfCenter = "_12-a";
export var alignSelfFlexEnd = "_12-c";
export var alignSelfFlexStart = "_12-b";
export var alignSelfStretch = "_12-d";
export var alignStretch = "_12-8";
export var column = "_12-2";
export var columnReverse = "_12-4";
export var flex = "_12-0";
export var justifyCenter = "_12-f";
export var justifyFlexEnd = "_12-h";
export var justifyFlexStart = "_12-g";
export var justifySpaceAround = "_12-j";
export var justifySpaceBetween = "_12-i";
export var justifySpaceEvenly = "_12-k";
export var row = "_12-1";
export var rowReverse = "_12-3";
export var wrapNowrap = "_12-m";
export var wrapWrap = "_12-l";
export var wrapWrapReverse = "_12-n";